import React from "react";
import markDark from "@/assets/emg-mark.png";        // navy + gold on transparent (for light backgrounds)
import markLight from "@/assets/emg-mark-light.png";  // white + gold on transparent (for dark backgrounds)

// Official EMG 360 mark. Use `light` on dark/navy backgrounds.
export const Logo = ({ className = "h-9", light = false }) => (
  <img
    src={light ? markLight : markDark}
    alt="EMG Performance 360"
    className={`${className} w-auto`}
  />
);
